import { InputNumber } from "antd";

export const TwoDecimalInput = ({ ...others }) => {
  return (
    <InputNumber
      min={0}
      step={0.01}
      formatter={(value) => `${parseFloat(value || 0).toFixed(2)}`}
      parser={(value) => value.replace(/[^\d.]/g, "")}
      {...others}
    />
  );
};

export default TwoDecimalInput;
